<template>
  <div class="com-banner">
    <img :src="bannerUrl">
    <div class="container" v-if="title || text">
      <div v-if="title" class="banner_title">{{ title }}</div>
      <div v-if="text" class="banner_text" v-html="text"></div>
      <div class="banner_content">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
defineProps({
  bannerUrl: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  text: {
    type: String,
    default: ''
  },
});

</script>

<style lang="less" scoped>
.com-banner {
  position: relative;
  img {
    width: 100%;
    height: auto;
  }
  .container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, 0);
    font-size: 50px;
    color: #fff;
  }
  .banner_title {
    position: absolute;
    top: 32.7%;
    left: 0;
    line-height: 100%;
    font-size: 50px;
  }
  .banner_text {
    position: absolute;
    top: 45.45%;
    left: 0;
    line-height: 100%;
    font-size: 18px;
  }
  .banner_content {
    position: absolute;
    top: 42%;
    left: 0;
    display: flex;
    flex-direction: column;
  }
}
@media screen and (max-width: 1180px) {
  .banner_title {
    font-size: calc(0.04 * 100vw)!important;
  }
  .banner_text {
    font-size: calc(0.015 * 100vw)!important;
    
  }
}
</style>